export { default } from "./Paragraph";
